export const FEEDBACK_FORM_CONFIG = {
  comment: {
    maxRows: 4,
    maxLength: 1000,
  },
};

export const FEEDBACK_FORM_FALLBACK_VALUES = {
  comment: '-',
};
